import React, { useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { getAuthorizationHeader } from '../../../utils/auth';
import { fetchRequest } from '../../../utils/fetchRequest';
import Row from '../../Structure/Row';
import Group from '../../Structure/Group';
import Button from '../../Button';

const DeleteModalConstructor = (props) => {
  const {
    hideModal,

    DELETE_REQUEST_URL,
    DELETE_STATIC_HINT,
    DELETE_STATIC_VALUE,
  } = props;

  const deleteProperty = useCallback(() => {
    const fetchDelete = async () => {
      const options = {
        method: 'DELETE',
        headers: {
          'Authorization': getAuthorizationHeader(),
        },
      };

      const url = DELETE_REQUEST_URL;
      const { success } = await fetchRequest(url, options);

      if (success) {
        window.location.reload();
      }
    };

    fetchDelete();
  }, [DELETE_REQUEST_URL]);

  return (
    <ConfirmDeleteContainer>
      <Row>
        {DELETE_STATIC_HINT}:<ContextName>{DELETE_STATIC_VALUE}</ContextName>
      </Row>
      <Group align='right'>
        <Button label='Отмена' theme='hollow' onClick={hideModal} />
        <Button label='Удалить' color='alert' onClick={deleteProperty} />
      </Group>
    </ConfirmDeleteContainer>
  );
};

const ConfirmDeleteContainer = styled.div`
  ${({ theme }) => theme.mixins.gothamRegular()};
  font-size: ${({ theme }) => theme.fonts.sizes[theme.userSettings.fontSize]};
`

const ContextName = styled.span`
  ${({ theme }) => theme.mixins.gothamSemibold()};
  font-size: ${({ theme }) => theme.fonts.sizes[theme.userSettings.fontSize]};
`

DeleteModalConstructor.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default DeleteModalConstructor;